import React from 'react';

import styled from '@emotion/styled';

import ExternalLinkIcon from '../Icons/ExternalLinkIcon';

interface IExternalLinkButton {
  children: string | React.ReactNode;
  className?: string;
  href: string;
}

export const ExternalLinkButton: React.FC<IExternalLinkButton> = ({
  children,
  className,
  href,
}) => {
  return (
    <FormSubmitAnchor
      className={className ? className : ''}
      href={href}
      target='_blank'
      rel='noopener noreferrer'
    >
      {children}
      <ExternalLinkIcon />
    </FormSubmitAnchor>
  );
};

export const FormSubmitBtn = styled.button`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 6px;
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 11px;
  text-decoration: underline;
  width: fit-content;

  color: ${({ theme }) => theme.palette.blueColor};
  background-color: white;
  height: fit-content;
  cursor: pointer;

  &.borderless {
    border: none;
    padding: 12px 0px;

    @media (max-width: 884px) {
      text-align: left;
      padding: 0px;
      justify-content: flex-start;
    }
  }

  &.mobile-border {
    @media (max-width: 884px) {
      border: 1px solid ${({ theme }) => theme.palette.borderColor};
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      padding: 12px 16px;
    }
  }
`;

export const FormSubmitAnchor = styled.a`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 6px;
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 11px;
  text-decoration: underline;
  width: fit-content;

  color: ${({ theme }) => theme.palette.blueColor};
  background-color: white;
  height: fit-content;
  cursor: pointer;

  &.borderless {
    border: none;
    padding: 12px 0px;

    @media (max-width: 884px) {
      text-align: left;
      padding: 0px;
      justify-content: flex-start;
    }
  }

  &.mobile-border {
    @media (max-width: 884px) {
      border: 1px solid ${({ theme }) => theme.palette.borderColor};
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      padding: 12px 16px;
    }
  }
`;
